export default __webpack_public_path__ + "static/scientist10-f2d6592eabc5c706d12616f794d475a1.jpg";